import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const Skill = ({ name, x, y }) => {
  return (
    <motion.div
      className="flex absolute justify-center bg-[#1c3054] rounded-full p-3 w-min hover:scale-105 cursor-pointer text-[#b6bccd] items-center"
      whileHover={{ scale: 1.05 }}
      initial={{ x: 0, y: 0 }}
      whileInView={{ x: x, y: y }}
      transition={{ duration: 1.5, delay: 1 }}
      viewport={{ once: true }}
    >
      {name}
    </motion.div>
  );
};

const About = () => {
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions();

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  };
  // let skill = window>1023 ?

  return (
    <div id="about" className="min-h-[700px] mt-6 ">
      <div>
        <span className="text-[#64ffda] ml-[8%] text-xl">02. </span>
        <span className="text-gray-200 text-2xl title font-extrabold">
          About Me
        </span>
      </div>

      <div className="md:flex mt-6">
        <div className=" title sm:ml-[60px] text-[16px] p-7  md:w-[40%]  text-[#99a3c2]  rounded-md text-start">
          👋 Hello there! I'm Gurjit Singh, a passionate technologist driven to
          harness cutting-edge technologies for innovation and problem-solving.
          I thrive in dynamic environments that demand adaptability and
          continuous learning.
          <br></br>
          <br></br>
          🚀 My web development journey began with a deep dive into HTML and
          CSS, igniting a relentless pursuit of knowledge in React and API
          integration. I actively participate in coding challenges on platforms
          like
          <span className="text-[#64ffda] ml-1 hover:underline cursor-pointer">
            <a
              href="https://leetcode.com/guru92921/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Leetcode
            </a>
          </span>{" "}
          and
          <span className="text-[#64ffda] ml-1 hover:underline cursor-pointer">
            <a
              href="https://www.codechef.com/users/guru92921"
              target="_blank"
              rel="noopener noreferrer"
            >
              CodeChef
            </a>
          </span>
          , and as Tech Head at DJS Init.AI, I'm dedicated to staying abreast of
          the latest advancements in AI.
          <br></br>
          <br></br>
          🔍 I've also emerged as a hackathon winner and developed
          industry-ready applications during internships.
          <br></br>
          <br></br>
          🎓 Currently pursuing a degree in Information Technology from DJ
          Sanghvi College of Engineering, I've maintained an outstanding CGPA of
          9.26 while juggling various commitments.
          <br></br>
          <br></br>
          💼 If you're seeking a dynamic collaborator who combines technical
          expertise, research acumen, and adaptability, let's connect! I'm eager
          to explore new opportunities and contribute to projects that push the
          boundaries of innovation.
          <br></br>
        </div>
        <div className="md:w-[50%]  flex justify-center items-center rounded-full skills">
          {width > 1023 ? (
            <>
              <div className="flex shine justify-center bg-[#1c3054] rounded-full px-5 py-4 w-min hover:scale-105 cursor-pointer text-white z-10 items-center">
                Skills
              </div>
              <Skill name="C++" x="-12vw" y="-11vw" />
              <Skill name="MySQL" x="-7vw" y="9vw" />
              <Skill name="Git" x="-12vw" y="-5vw" />
              <Skill name="Next.js" x="1vw" y="4vw" />
              <Skill name="React" x="1vw" y="8vw" />
              <Skill name="tailwind" x="-2vw" y="-4vw" />
              <Skill name="CSS" x="-7vw" y="4vw" />
              <Skill name="MongoDB" x="8vw" y="-3vw" />
              <Skill name="JavaScript" x="12vw" y="5vw" />
              <Skill name="Java" x="11vw" y="-12vw" />
              <Skill name="Python" x="12vw" y="11vw" />
            </>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default About;
